import useGetUrlParams from "../../hooks/useGetUrlParams.js";
import useAvailableBrandedFares from "./useAvailableBrandedFares.js";
const useIsBrandedFare = (options) => {
    const brandedFareOffers = useAvailableBrandedFares();
    const { getUrlParam } = useGetUrlParams();
    const isClient = process.env.BUILD_TARGET === "client";
    const hasBaseOffer = isClient && !!getUrlParam("baseOfferToken");
    const hasSelectedFareIndex = isClient && !!getUrlParam("selectedFareIndex");
    const hasOrderBrandedFare = !!options?.brandedFareInfo;
    return brandedFareOffers.length > 0 || hasBaseOffer || hasSelectedFareIndex || hasOrderBrandedFare;
};
export default useIsBrandedFare;
